export default __webpack_public_path__ + "images/42934121d145d5f210315941b5b4163f-cc-mini-back@2x.png";